
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fr/courtiers/devenez-partenaires",
      function () {
        return require("private-next-pages/fr/courtiers/devenez-partenaires.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fr/courtiers/devenez-partenaires"])
      });
    }
  